import { render, staticRenderFns } from "./CandidatesLabel.vue?vue&type=template&id=5f56dcf6&scoped=true&lang=pug&"
import script from "./CandidatesLabel.vue?vue&type=script&lang=js&"
export * from "./CandidatesLabel.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesLabel.vue?vue&type=style&index=0&id=5f56dcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56dcf6",
  null
  
)

export default component.exports